export default initialState => ({
  PURGE: state => {
    console.info('PURGING...');

    return initialState;
  },
});
